import React, { memo } from 'react';
import { Box, Divider } from '@mui/material';

import { InsertionProfileAtticSettings } from '../../../properties/AtticSettings';
import { ActiveComponentGableSettings } from '../../../properties/GableSettings';
import HeelSettings from '../../../properties/HeelSettings';
import { ActiveComponentJackSettings } from '../../../properties/JackSettings';
import { LabeledBox } from '../../../properties/LabeledBox';
import { InsertionProfilePiggybackSettings } from '../../../properties/PiggybackSettings';
import { ProfileInsertionOverhangSettings } from '../../../properties/ProfileInsertionOverhangSettings';
import { ProfileCreator } from '../profile-creator/ProfileCreator';
import { Length } from './Length';

const FreeformProfileShapeDetails = () => {
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Length />
      </Box>

      <Divider sx={{ marginTop: 2 }} />

      <ProfileCreator />

      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <LabeledBox title="Left Heel">
          <HeelSettings side="Left" />
        </LabeledBox>
        <LabeledBox title="Right Heel">
          <HeelSettings side="Right" />
        </LabeledBox>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <LabeledBox title="Left Overhang">
          <ProfileInsertionOverhangSettings side="left" />
        </LabeledBox>
        <LabeledBox title="Right Overhang">
          <ProfileInsertionOverhangSettings side="right" />
        </LabeledBox>
      </Box>

      <LabeledBox title="Gable Settings">
        <ActiveComponentGableSettings />
      </LabeledBox>

      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <LabeledBox title="Jack Settings">
          <ActiveComponentJackSettings />
        </LabeledBox>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <LabeledBox title="Piggyback Settings">
          <InsertionProfilePiggybackSettings />
        </LabeledBox>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <LabeledBox title="Attic Settings (Beta)">
          <InsertionProfileAtticSettings />
        </LabeledBox>
      </Box>
    </>
  );
};

// This component and its children account for a majority of the render time when the profile is edited during truss
//   insertion. Performance is vital here -- since the insertion profile is stored in redux state, the insertion panel
//   is sometimes re-rendered on each tick of a mouse move event, such as when dragging profile joints.
//
// As a component with no props this is a trivial place to memoize, and it gives us a significant performance boost
//   since stopping here can save a majority of the panel from being rendered.
export default memo(FreeformProfileShapeDetails);
